import { keyframes } from 'styled-components'

export const rightAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
  }

`
